import React, { Component } from "react";
import { ENocMollakProps, EnocTrackIndex } from "./index";
import { RadioInput } from "@my-dld/components/RadioInput";
import Strings from "@my-dld/assets/strings";
import { BuyerInfo, ENocMLookUp, ENocMLookupData, Mode, OwnerType } from "../../enocapi/entities";
import { LocaleUtil } from "@eres/core";
import {
	normalizeEIdaPersonToMollak,
	normalizeTabuPersonToMollak,
	populateENocMLookup,
	validateCompanyForm,
	validateDocuments,
	validatePersonForm
} from "../../enocapi/services";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import DocEnocM from "./DocEnocM";
import CompanyInfo from "./CompanyInfo";
import PersonInfo from "./PersonInfo";
import TextInputField from "@my-dld/components/Form/TextInputField";
import * as ENocMApi from "../../enocapi/api";

interface Props extends ENocMollakProps {

}

interface ENOCLookupState {
	OwnershipTypes: ENocMLookupData[];
}

interface State extends ENOCLookupState, BuyerInfo {
	docsError?: any,
	propertyShareValue?: number,
	uaeResidenceVerified: boolean,
	disableOwnershipType: boolean,
	resetAll: boolean,
}

export default class BuyerDetails extends Component<Props, State> {
	personRef: PersonInfo | null | undefined;
	companyRef: CompanyInfo | null | undefined;
	documentRef: Component<any, any, any> | null | undefined;

	constructor( props: Props ) {
		super( props );
		const buyerIndex = props.getIndex();
		const buyer = props.getData( buyerIndex ) as BuyerInfo;
		this.state = {
			OwnershipTypes: [],
			...buyer,
			uaeResidenceVerified: buyer && buyer.emiratesID !== undefined,
			disableOwnershipType: buyer && buyer.ownershipType !== undefined,
			resetAll: false,
		};
	}

	componentDidMount(): void {
		populateENocMLookup( ENocMLookUp.OWNERSHIP_TYPE, this, () => {
			const allTypes = this.state.OwnershipTypes;
			if ( allTypes.length > 0 && this.state.ownershipType === undefined ) {
				allTypes.sort( function ( a, b ) {
					return a.identity! - b.identity!;
				} );
				this.setState( { ownershipType: allTypes[ 0 ], OwnershipTypes: allTypes } );
			}
		} );
	}

	OnSwitchUAEResidence = ( isResident: boolean ) => {
		this.setState( { ...resetPersonBuyer(), isUAEResident: isResident, uaeResidenceVerified: false, } );
	};

	render() {
		const state = this.state;
		const buyerIndex = this.props.getIndex();
		const buttonLabel = buyerIndex === -1 ? Strings.add_buyer : Strings.update_buyer;
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		const isView = this.state.mode === Mode.VIEW;
		const enocModel = this.props.getENocData();
		return <React.Fragment>
			<div className="card">
				<div className="card-body">
					<div className="row">
						<RadioInput
							holder={ this }
							containerClassName={ "col-md-12" }
							label={ Strings.ownership_type }
							id={ "ownershipType" }
							toIdentifier={ ( item: ENocMLookupData ) => item.identity + "" }
							formatter={ item => LocaleUtil.getLocalValue( item ) }
							disabled={ state.mode === Mode.VIEW || state.mode === Mode.EDIT || state.disableOwnershipType }
							items={ this.state.OwnershipTypes }
							onValueChange={ value => {
								this.setState( { ...resetPersonBuyer(), uaeResidenceVerified: false, ownershipType: value } );
							} }
						/>
					</div>
				</div>
			</div>
			{
				state.ownershipType?.identity === OwnerType.COMPANY && <>
					<div className="card">
						<div className="card-header">
							<span>{ Strings.company_information }</span>
						</div>
						<div className="card-body">
							<div className="mandatory-field-info">
								<small>{ Strings.mandatory_fields_note }</small>
							</div>
							<CompanyInfo { ...this.state } ref={ ( ref ) => this.companyRef = ref } resetAll={ this.state.resetAll }/>
						</div>
					</div>
					<div className="card">
						<div className="card-header">
							<span className="section-title-span">{ Strings.authorized_person_information }</span>
						</div>
						<div className="card-body">
							<div className="mandatory-field-info">
								<small>{ Strings.mandatory_fields_note }</small>
							</div>
							<PersonInfo { ...this.state } ref={ ( ref ) => this.personRef = ref } resetAll={ this.state.resetAll }
							            isCompany={ true }
							            onDNRD={ this.onSearchCall }
							            onSwitch={ this.OnSwitchUAEResidence }
							            uaeResidenceVerified={ this.state.uaeResidenceVerified }/>
						</div>
					</div>
				</>
			}
			{
				state.ownershipType?.identity === OwnerType.INDIVIDUAL &&
				<div className="card">
					<div className="card-header">
						<span>{ Strings.person_information }</span>
					</div>
					<div className="card-body">
						<div className="mandatory-field-info">
							<small>{ Strings.mandatory_fields_note }</small>
						</div>
						<PersonInfo { ...this.state } ref={ ( ref ) => this.personRef = ref! } resetAll={ this.state.resetAll }
						            onDNRD={ this.onSearchCall }
						            onSwitch={ this.OnSwitchUAEResidence }
						            uaeResidenceVerified={ this.state.uaeResidenceVerified }/>
					</div>
				</div>
			}
			<div className="card">
				<div className="card-header">
					<span>{ Strings.property_size }</span>
				</div>
				<div className="card-body">
					<div className="alert alert-info fit-content">
						<span>{ Strings.total_area_size_enoc }
							<b>{ enocModel.totalArea + " " + Strings.sq_mt }</b> { Strings.total_size_eq_to_property_size }</span>
					</div>
					<div className="row">
						<div className="col-md-4">
							<TextInputField
								{ ...kvProp }
								id={ "propertyShareValue" }
								type={ "number" }
								required={ true }
								label={ Strings.share_value + " (" + Strings.sq_mt + ")" }
								disabled={ isView }
								containerClassName="form-group"
							/>
						</div>
					</div>
				</div>
			</div>
			<DocEnocM
				ref={ ( ref ) => this.documentRef = ref }
				mode={ this.state.mode }
				documents={ this.state.documents! }
				docsError={ this.state.docsError }
				ownershipType={ this.state.ownershipType! }
				isUAEResident={ this.state.isUAEResident! }/>
			{
				state.mode != Mode.VIEW &&
				<div className="row mb-3">
					<div className="col-md-12">
						<button className="btn btn_1" type="button" onClick={ this.saveData }>
							{ buttonLabel }
						</button>
						<a
							onClick={ buyerIndex === -1 ? this.resetAll : this.backToPage }
							className="btn btn-grey btn_style1 ms-2 me-2">{ buyerIndex === -1 ? Strings.reset : Strings.close_label }</a>
					</div>
				</div>
			}
			{
				state.mode === Mode.VIEW &&
				<div className="row mb-3">
					<div className="col-md-12">
						<button onClick={ this.backToPage } className="btn btn_1 btn_style1" type="submit">
							{ Strings.close_label }
						</button>
					</div>
				</div>
			}
		</React.Fragment>;
	}

	backToPage = () => {
		const buyers = this.props.getBuyers();
		if ( buyers && buyers.length > 0 ) {
			this.props.onPrevious( EnocTrackIndex.BUYER_LIST );
		} else {
			const property = this.props.getTabuProperty();
			replaceNavigate( "/mydld/" + "property/" + property.propertyTypeId + "/" + property.tabuPropertyId );
		}
	};

	resetAll = () => {
		const docs = this.documentRef?.state.documents;
		let p = docs?.map( ( value: any ) => {
			return {
				...value,
				docs: undefined,
				Path: undefined,
				serverId: undefined,
				url: undefined,
			};
		} );
		const isCompany = this.state.OwnershipTypes && this.state.OwnershipTypes.length > 0 && this.state.OwnershipTypes[ 0 ]?.identity === OwnerType.COMPANY;
		this.setState( {
			...resetPersonBuyer(), ...resetCompanyBuyer(),
			uaeResidenceVerified: false,
			documents: p,
			resetAll: true,
			isCompany: isCompany
		} );
	};

	getBuyerInfo() {
		const state = this.state;
		let nocLetterBuyerID = {};
		if ( state.mode === Mode.EDIT ) {
			nocLetterBuyerID = { nocLetterBuyerID: state.nocLetterBuyerID };
		}
		return {
			ownershipType: state.ownershipType,
			mode: state.mode,
			isCompany: state.isCompany,
			propertyShareValue: state.propertyShareValue,
			...nocLetterBuyerID,
		} as BuyerInfo;
	}

	saveData = () => {
		let p = this.personRef!;
		let c = this.companyRef!;
		let d = this.documentRef!;

		let buyer: BuyerInfo = this.getBuyerInfo();
		const isIndividual = this.state.ownershipType?.identity === OwnerType.INDIVIDUAL;
		let valid: boolean;
		if ( isIndividual ) {
			buyer = {
				...buyer,
				...p.getBuyerInfo(),
				documents: d.state.documents,
			};
			valid = validatePersonForm( buyer, p, false );
			if ( valid ) {
				valid = validateDocuments( buyer );
				if ( !valid ) showMessage( Strings.please_add_required_documents );
			}
		} else {
			buyer = {
				...buyer,
				...c.getBuyerInfo(),
				...p.getBuyerInfo(),
				documents: d.state.documents,
			};
			valid = validateCompanyForm( buyer, c );
			valid = validatePersonForm( buyer, p, true ) && valid;
			if ( valid ) {
				valid = validateDocuments( buyer );
				if ( !valid ) showMessage( Strings.please_add_required_documents );
			}
		}
		if ( buyer.isUAEResident && !( this.state.uaeResidenceVerified ) && buyer.mode != Mode.EDIT ) {
			// alert to verify account
			showMessage( Strings.verify_eid );
			valid = false;
		}
		if ( valid ) {
			const eNOCM = this.props.getENocData();
			if ( this.state.propertyShareValue && this.state.propertyShareValue !== 0
				&& this.state.propertyShareValue <= eNOCM?.totalArea! ) {
				buyer.propertyShareValue = this.state.propertyShareValue;
			} else {
				showMessage( Strings.please_enter_correct_share_value );
				valid = false;
			}
		}
		if ( valid ) {
			this.props.setData( buyer, this.props.getIndex(), () => {
				this.props.onPrevious( EnocTrackIndex.BUYER_LIST );
			} );
		}
	};

	onSearchCall = ( buyer: BuyerInfo ) => {
		let prevBuer: BuyerInfo = this.state;
		const isCompany = buyer.ownershipType?.identity === OwnerType.COMPANY;
		if ( buyer.isUAEResident && buyer.emiratesID ) {
			prevBuer.isCompany = isCompany;
			showLoading();
			if ( isCompany ) {
				this.searchInEIdaService( buyer );
			} else {
				this.searchInTabuService( buyer );
			}
		}
	};

	searchInEIdaService( buyer: BuyerInfo ) {
		ENocMApi.searchEIdaPerson( buyer.emiratesID! ).then( resp => {
			hideLoading();
			if ( resp && resp.person ) {
				buyer = normalizeEIdaPersonToMollak( resp.person!, buyer );
				const nameEn = buyer.isCompany ? buyer.ManagerNameEn : buyer.PersonNameEn;
				const nameAr = buyer.isCompany ? buyer.ManagerNameAr : buyer.PersonNameAr;
				if ( nameEn && nameAr && buyer.birthDate && buyer.nationality ) {
					this.setState( {
						...buyer,
						uaeResidenceVerified: true,
					} );
				} else {
					this.setState( { isUAEResident: false, uaeResidenceVerified: false } );
					showMessage( Strings.incomplete_information_in_system + "\n" + Strings.non_residence_info );
				}
			} else {
				this.setState( { isUAEResident: false, uaeResidenceVerified: false } );
				showMessage( Strings.user_not_found_in_system + "\n" + Strings.non_residence_info );
			}
		} ).catch( expEIda => {
			hideLoading();
			this.setState( { isUAEResident: false, uaeResidenceVerified: false } );
			showMessage( Strings.user_not_found_in_system + "\n" + Strings.non_residence_info );
		} );
	}

	searchInTabuService( buyer: BuyerInfo ) {
		ENocMApi.searchTabuPerson( buyer.emiratesID! ).then( resp => {
			hideLoading();
			const buyerTabu = normalizeTabuPersonToMollak( resp!, buyer );
			if ( buyerTabu.PersonNameEn && buyerTabu.PersonNameAr && buyerTabu.birthDate && buyerTabu.nationality ) {
				this.setState( {
					...buyer,
					uaeResidenceVerified: true,
				} );
			} else {
				this.searchInEIdaService( buyer );
			}
		} ).catch( exp => {
			this.searchInEIdaService( buyer );
		} );
	}
}

function resetPersonBuyer(): BuyerInfo {
	return {
		emiratesID: undefined,
		participantId: undefined,
		emiratesIdExpiry: undefined,
		ManagerNameEn: undefined,
		PersonNameEn: undefined,
		ManagerNameAr: undefined,
		PersonNameAr: undefined,
		nationality: undefined,
		companyName: undefined,
		passportNumber: undefined,
		gender: undefined,
		genderId: undefined,
		passportIssuedBy: undefined,
		startDate: undefined,
		endDate: undefined,
		birthPlace: undefined,
		birthDate: undefined,
		mobile: undefined,
		email: undefined,
		passportValidity: undefined,
		contact: undefined,
	} as BuyerInfo;
}

function resetCompanyBuyer(): BuyerInfo {
	return {
		emiratesID: undefined,
		propertyShareValue: undefined,
		CompanyNameEn: undefined,
		CompanyNameAr: undefined,
		tradeLicenseNumber: undefined,
		licenseAuthority: undefined,
	} as BuyerInfo;
}
